export type EventData = Record<string, string>
export type EventType = 'identify' | 'page' | 'track'

interface BaseEvent {
  id: string
  timestamp: string
  type: EventType
}

interface IdentifyEvent extends BaseEvent {
  data: EventData
  type: 'identify'
}

interface PageEvent extends BaseEvent {
  data: EventData & {
    meta: Record<string, string> & { page: Record<string, string> & { path: string } }
  }
  type: 'page'
}

interface TrackEvent extends BaseEvent {
  data: EventData & { name: string }
  type: 'track'
}

export type Event = IdentifyEvent | PageEvent | TrackEvent

interface ExistingEventMessage {
  type: 'existing_events'
  events: Event[]
}

interface NewEventMessage {
  type: 'new_event'
  event: Event
}

export type EventMessage = ExistingEventMessage | NewEventMessage

export const mapEventName = (event: Event) => {
  switch (event.type) {
    case 'identify':
      return 'identify'
    case 'page':
      return event.data.meta?.page?.path.split('/').pop()
    case 'track':
      return event.data.name
  }
}
